/**
 * Shared helpers for tier list data: base name normalization and ranking lookup.
 * Used by PokemonProfile.
 */

export function getBaseName(pokemonName) {
  if (!pokemonName || typeof pokemonName !== 'string') return '';
  return pokemonName
    .replace(/\s*\(Mega[^)]*\)/, '')
    .replace(/\s*\(Shadow\)/, '')
    .trim();
}

/**
 * Returns all tier list entries (across types and mega/non_mega) for a Pokémon
 * whose base name matches the given name. Sorted by rank then DPS.
 */
export function getRankingsForName(allTierLists, name) {
  if (!allTierLists) return [];
  const results = [];
  for (const [type, tierData] of Object.entries(allTierLists)) {
    if (type === 'attack_type') continue;
    for (const category of ['mega', 'non_mega']) {
      if (!tierData[category]) continue;
      for (const entry of tierData[category]) {
        const baseName = getBaseName(entry.pokemon_name);
        if (baseName.toLowerCase() === name.toLowerCase()) {
          results.push({ ...entry, attackType: type, category });
        }
      }
    }
  }
  results.sort((a, b) => a.rank - b.rank || b.combined_effective_dps - a.combined_effective_dps);
  return results;
}
